import { apiFetch } from "./fetchApi";

export const fetchTeamLead = async (companyId, BeURL, showAlert, reportingManagerId, setTeamleadIds) => {
    try {


        // 2️⃣ Send companyId as param for get manager Ids creation
        const accountRes = await apiFetch(`${BeURL}/recruiter/${reportingManagerId}/${companyId}`, {
            method: "GET",
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        setTeamleadIds(accountData.teamlead)


    } catch (err) {
        console.error("Error in fetch Team lead:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }

}